import React from "react";
import WogComponent from "../../AppLocals/WoG/WogComponent";

// Khung hình chữ nhật, 1 chiều cao ổn định ngay từ đầu (min-h-48, không đổi qua timer như trước)
// để tránh layout-shift/render lại khi load xong — LoadingBlock bên trong (WogComponent) đã tự lo
// placeholder cùng min-height nên không cần state "autoHeight" chuyển pha nữa.
export const GodWordsBlock = React.memo(({style = {}}) => (
    <div
        className="p-4 w-full flex flex-col flex-center shadow-block rounded-3xl min-h-48"
        style={{
            background: `linear-gradient(135deg, #0f2942 0%, #1c4a75 100%)`,
            fontFamily: "'Montserrat', sans-serif",
            ...style
        }}>
        <WogComponent today={1}/>
    </div>
))
